import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  update(event) {
    let button = event.target

    this.element.action = button.dataset.url
    this.element.method = button.dataset.method
  }
}